import React, { Fragment, useContext } from "react";
import { PERIODS } from "../content/index.content";
import { MediaAuthContext } from "../../../../store/context/media-auth-context";
import PropTypes from "prop-types";
import Table from "../Table";
import Navigation from "./Navigation";
import "./index.scss";

const Toggle = ({ refs: { toggleRef, ...navRefs } }) => {
  const {
    media: { isNotInitMobile },
  } = useContext(MediaAuthContext);
  return (
    <div className="GP-C-To" ref={toggleRef}>
      {PERIODS.map((period) => (
        <Fragment key={period}>
          <Navigation period={period} navRef={navRefs[`${period}NavRef`]} />
          {isNotInitMobile && <Table period={period} />}
        </Fragment>
      ))}
    </div>
  );
};
Toggle.propTypes = {
  refs: PropTypes.object,
};
export default Toggle;
